import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  const login = (role = 'admin') => {
    setIsAuthenticated(true);
    setUser({
      name: role === 'student' ? 'Aarav Sharma' : 'Dr. Sarah Mitchell',
      role,
      email: 'user@institute.edu',
      academicYear: '2025-2026'
    });
  };

  const logout = () => {
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};